import React, { useState, useRef, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "url-search-params-polyfill";
import Search from "../shared/Search";

export default function SearchModal({
  searchPageLink,
  searchFor,
  placeholder
}) {
  const [searchValue, updateSearchValue] = useState("");
  const [isOpen, updateOpen] = useState(false);
  const modalInput = useRef(null);
  const overlay = useRef(null);

  const isSearchPage = document.querySelector(".TheHubSearchResultsPage");
  const overflowContainer = document.querySelector(".overflow-container");

  const doSearch = () => {
    if (searchValue) {
      window.location.assign(
        `${window.location.origin + searchPageLink}?q=${searchValue}`
      );
    }
  };

  const handleOnClick = () => {
    if (isSearchPage) {
      const searchPageInput: HTMLElement = document.querySelector(
        "#search-page-container .site-search"
      );
      searchPageInput.focus();
    } else {
      updateOpen(!isOpen);
      if (overflowContainer.classList.contains("hidden")) {
        document.body.classList.remove("overflow-hidden");
        overflowContainer.classList.remove("hidden");
        modalInput.current.blur();
      } else {
        document.body.classList.add("overflow-hidden");
        overflowContainer.classList.add("hidden");
        overlay.current.addEventListener(
          "animationend",
          () => {
            modalInput.current.focus();
          },
          { once: true }
        );
        overlay.current.addEventListener(
          "webkitAnimationEnd",
          () => {
            modalInput.current.focus();
          },
          { once: true }
        );
      }
    }
  };

  useEffect(() => {
    if (isSearchPage) return;
    if (isOpen) {
      document.body.classList.add("search-overlay-open");
    } else {
      document.body.classList.remove("search-overlay-open");
    }
  }, [isOpen]);

  return (
    <div className={`search-modal ${!isSearchPage && isOpen && "open"}`}>
      <div className="search-circle" />
      <button
        className="header-control header-control--search"
        aria-label="Open/Close Search"
        title="Open/Close Search"
        onClick={handleOnClick}
      >
        {isOpen ? (
          <img src="/dist/icons/times.svg" alt="" className="icon-invert" />
        ) : (
          <img src="/dist/icons/search.svg" alt="" className="icon-invert" />
        )}
      </button>
      <div
        className="search-overlay"
        ref={overlay}
        aria-live={isOpen ? "assertive" : "off"}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5>{searchFor}</h5>
              <Search
                searchValue={searchValue}
                changeSearchValue={updateSearchValue}
                doSearch={doSearch}
                label="Website"
                className="site-search"
                placeholder={placeholder}
                reactRef={modalInput}
                disabled={!isOpen}
                inModal
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
